import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';
import { TipoActividad } from 'src/app/app.config/app.config-beneficios';
import { TipoActividadService } from 'src/app/services/tipo-actividad.service'; // Servicio para manejar categorías
import { MediaService } from '@services/shared/media.service';
import { Subscription } from 'rxjs';
import { environment } from '@env/environment';
import { readImagePreview } from '@shared/utils/image-upload.util';

@Component({
  selector: 'app-modificacion-categoria',
  templateUrl: './modificacion-categoria.component.html',
  styleUrls: ['./modificacion-categoria.component.scss']
})
export class ModificacionCategoriaComponent implements OnInit {

  imageUrl: string | ArrayBuffer = './assets/img/uploadImg.png';
  esHeic = false;
  file: File;
  selectedFile: File;
  fileName = 'No file selected';
  cargandoArchivo = false;
  flagProcesando = false;
  subscriptionAvance: Subscription;
  condition = false;

  myModel = true;
  form: FormGroup;
  estado = true;
  flagLoaded = false;

  categoria: TipoActividad;

  constructor(
    private router: Router,
    private tipoActividadService: TipoActividadService,
    public guiMsjService: GuiMsjService,
    private mediaService: MediaService
  ) {
    this.getCategoria();
    this.getEstadoVariables();
  }

  ngOnInit(): void {
    this.getEstadoVariables();
    this.createForm();

    if (this.categoria?.imagen) {
      this.imageUrl = `${environment.urlBackend}/media/getUrlMediaOfertaLaboral/1/${this.categoria.imagen}`;
    }
  }

  // Validación del campo "denominacion"
  get denominacionNoValida() {
    return this.form.get('denominacion').invalid && this.form.get('denominacion').touched;
  }

  createForm() {
    this.form = new FormGroup({
        denominacion: new FormControl(this.categoria?.denominacion, [Validators.required]),
        size: new FormControl(this.categoria?.size, [Validators.required]),
        imagen: new FormControl('')
    });
  }

  async put() {
    this.flagProcesando = true;

    try {
        // Primero actualiza los datos principales
        await this.tipoActividadService.updateTipoActividad(
            this.categoria._id,
            await this.setDataForma()
        ).toPromise();

        // Luego sube la imagen si hay archivo seleccionado
        if (this.selectedFile) {
            await this.uploadFile(this.selectedFile, this.categoria._id);
        }

        this.router.navigate(['/listado-categoria']);
    } catch (error) {
        console.error('Error al actualizar', error);
    } finally {
        this.flagProcesando = false;
    }
  }  

  async setDataForma(): Promise<TipoActividad> {
    return {
        _id: this.categoria._id, // Asegúrate de incluir el ID
        denominacion: this.form.value.denominacion,
        size: this.form.value.size,
        imagen: this.categoria.imagen, // Mantiene la imagen existente
        activo: this.form.value.activo
    };
  }

  // Obtener la categoría seleccionada
  getCategoria() {
    return this.categoria = this.tipoActividadService.getCategoriaSeleccionada();
  }

  // Verificación del estado inicial y redirección en caso de error
  async getEstadoVariables() {
    if (!this.getCategoria()) {
      this.router.navigateByUrl('/'); // Redirige si no hay categoría seleccionada
      return;
    } else {
      await this.getCategoria();
      this.flagLoaded = true;
    }
  }

  onChangeFile(file: File, event) {
    if (file) {
        this.selectedFile = file;
        this.file = file;
        this.fileName = file.name;

        readImagePreview(file,
            value => {
                this.imageUrl = value;
                this.esHeic = false;
            },
            () => {
                this.esHeic = true;
                this.imageUrl = null;
            }
        );
    }
  }

  async uploadFile(selectedFile: File, idCategoria: string) {
    this.cargandoArchivo = true;
    try {
        const result = await this.mediaService.uploadImgTipoActividad(selectedFile, idCategoria);
        if (!result) throw new Error('Upload fallido');
    } catch (error) {
        this.guiMsjService.msjFormSubmit('uploadDocumentERROR');
    } finally {
        this.cargandoArchivo = false;
    }
  }

}
